import { useMutation } from "@tanstack/react-query";
import { CREATE_USER } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import { IUser } from "models/Employee";
import { FieldValues } from "react-hook-form";

type Props = {
  callback?: () => void;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useCreateUserMutation = ({ callback, showSnackbar }: Props) => {
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
    mutate,
  }: IReturnType<ApiResponseData<IUser>> = useMutation(
    [CREATE_USER],
    ({payload}:{payload:FieldValues}) => {
      console.log("Form Data Before Submit:", payload);
      return fetchApi(`register`).post(`register`, payload);
    },
    {
      onSuccess: (data) => {
        showSnackbar && showSnackbar("User Created Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Create New User", "error");
      },
    }
  );

  return { data: response?.data, isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useCreateUserMutation;
